module.exports = __webpack_public_path__ + "static/media/youtube.e1acda5b.svg";